/**
 * stateCatalogElement
 * @param $prd
 * @param $btn
 * @param state
 * @param addition
 * @returns {boolean}
 */
const stateCatalogElement = function ($prd, $btn, state, addition = {}) {
	let addition_default = {
		prd: {
			class: ''
		},
		btn: {
			classes: {
				add: '',
				del: ''
			},
			title: {
				isTitleText: true,
				isTooltipText: false,
				text: {
					add: '',
					del: ''
				}
			}
		}
	}

	addition = mergeDeepObject(addition_default, addition);

	if (state === 'del') {
		$prd.removeClass(addition.prd.class);
		$btn.attr('data-action', 'add');

		if (addition.btn.title.isTitleText) {
			$btn.html(addition.btn.title.text.add);
		}

		if (addition.btn.title.isTooltipText) {
			$btn.tooltip('dispose').attr('title', addition.btn.title.text.add).tooltip('enable');
		}

		$btn.removeClass(addition.btn.classes.del).addClass(addition.btn.classes.add);
	} else if (state === 'add') {
		$prd.addClass(addition.prd.class);
		$btn.attr('data-action', 'del');

		if (addition.btn.title.isTitleText) {
			$btn.html(addition.btn.title.text.del);
		}

		if (addition.btn.title.isTooltipText) {
			$btn.tooltip('dispose').attr('title', addition.btn.title.text.del).tooltip('enable');
		}

		$btn.removeClass(addition.btn.classes.add).addClass(addition.btn.classes.del);
	}

	$btn.blur();

	return false;
}

/**
 * Глубокое объединение объектов
 * @param objects
 * @returns {*}
 */
function mergeDeepObject(...objects) {
	const isObject = obj => obj && typeof obj === 'object';

	return objects.reduce((prev, obj) => {
		Object.keys(obj).forEach(key => {
			const pVal = prev[key];
			const oVal = obj[key];

			if (Array.isArray(pVal) && Array.isArray(oVal)) {
				prev[key] = pVal.concat(...oVal);
			}
			else if (isObject(pVal) && isObject(oVal)) {
				prev[key] = mergeDeepObject(pVal, oVal);
			}
			else {
				prev[key] = oVal;
			}
		});

		return prev;
	}, {});
}

export {stateCatalogElement, mergeDeepObject}
